// opervex-frontend/src/components/CurrencyInput.js

import React from "react";
import { Form } from "react-bootstrap";
import { NumericFormat } from "react-number-format";

const currencyMap = {
  BRL: "R$ ",
  USD: "$ ",
  EUR: "€ ",
};

const CurrencyInput = ({ value, onChange, label, hidden, disabled, name, showDisabled, currency = "BRL", size = "sm" }) => {
  const prefix = currencyMap[currency] || "";
  const numericValue = typeof value === "number" || typeof value === "string" ? value : 0;

  return (
    <Form.Group>
      {label && <Form.Label>{label}</Form.Label>}

      {!showDisabled && disabled ? (
        <div>
          {prefix}
          {new Intl.NumberFormat("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(numericValue || 0)}
        </div>
      ) : (
        <NumericFormat
          value={numericValue}
          onValueChange={(values) =>
            onChange({
              target: {
                name,
                value: values.floatValue ?? 0,
              },
            })
          }
          thousandSeparator="."
          decimalSeparator=","
          size={size}
          prefix={prefix}
          decimalScale={2}
          fixedDecimalScale
          name={name}
          hidden={hidden}
          disabled={disabled}
          customInput={Form.Control}
        />
      )}
    </Form.Group>
  );
};

export default CurrencyInput;
